import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdSortableHeader } from 'src/app/shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { Member } from './admin-manage-chat-ai.model';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-manage-chat-ai',
  templateUrl: './admin-manage-chat-ai.component.html',
  styleUrls: ['./admin-manage-chat-ai.component.scss'],
})
export class AdminManageChatAIComponent implements OnInit {
  public totalActiveUsers: number = 0;
  public totalReferrals: number = 0;
  public page = 1;
  public pageSize = 10;
  public dataFiles: any = [];
  public file: any = null
  public note: string = ''
  fileName = 'Choose file'
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this._getfilesDetails();
  }

  /**
   * get member details based on created date - dateCreated
   */
  async _getfilesDetails() {
    this.auth.chatGetFiles().subscribe((resp) => {
      this.dataFiles = resp.body
    })
  }

  uploadFiles(isUrl = false) {
    if (this.file == null) {
      this.toastr.error("Please Upload File ")
      return
    }
    if (this.note == '' && isUrl) {
      this.toastr.error("Please Write a Note !")
      return
    }

    const formData = new FormData()
    formData.append('file', this.file)
    formData.append('note', this.note)

    this.local.alertLoading({})
    this.auth.chatUploadFiles(formData).subscribe(() => {
      Swal.close()
      this.modalService.dismissAll()
      this.toastr.success("SUCCESS")
      this._getfilesDetails()
      Swal.close()
    }, (e) => {
      this.toastr.error("FAILED")
      Swal.close()
    })
  }

  openUploadModal(modal: any) {
    this.file = null
    this.modalService.dismissAll();
    this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });
  }

  onFileChange(event: any) {
    this.file = null
    if (event.target.files && event.target.files.length > 0) {
      this.file = event.target.files[0];
      this.fileName = this.file.name; // Update the fileName with the selected file name
    } else {
      this.fileName = 'Choose file'; // Reset to default if no file is selected
    }
  }

  handleDelete(file: string) {
    this.local.alertConfirm({
      message: `Are you sure want to delete ${file} ?`
    }).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({})
        this.auth.chatDeleteFiles({
          file_name: file
        }).subscribe((resp) => {
          this._getfilesDetails()
          this.toastr.success("SUCCESS")
          Swal.close()
        }, (e) => {
          this.toastr.error("FAILED")
          Swal.close()
        })
      }
    })
  }
}
